import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";
import "./css/adaptive.css";
import "./css/global.css";
import { HashRouter } from "react-router-dom";
import Navigation from "./components/Navigation/Navigation";
import Footer from "./components/Footer/Footer";
import { I18nProvider } from "./i18n/I18n";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element was not found");
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <I18nProvider>
      <HashRouter>
        <Navigation />
        <Footer />
        <Toaster
          position="bottom-center"
          containerStyle={{ bottom: 24 }}
          toastOptions={{
            duration: 3500,
            style: {
              background: "var(--surface)",
              color: "var(--text)",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius-md)",
              boxShadow: "var(--shadow-soft)",
              maxWidth: "min(420px, calc(100vw - 32px))",
            },
            success: {
              iconTheme: {
                primary: "var(--primary)",
                secondary: "var(--text)",
              },
            },
          }}
        />
      </HashRouter>
    </I18nProvider>
  </React.StrictMode>,
);
